module.exports = __webpack_public_path__ + "img/from-scratch.d03195db.svg";